import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import EmailGroupLayer from '../components/EmailGroupLayer';

const EmailGroupPage = () => {
  return (
    <MasterLayout pageTitle='Email Groups'>
      <EmailGroupLayer />
    </MasterLayout>
  );
};

export default EmailGroupPage;
